import React from "react";
import { GALLERY, FAQS, BRAND, IMAGES } from "../mock";

const scrollTo = (e, href) => {
  if (href && href.startsWith("#")) {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Day = () => (
  <section className="card day" id="day">
    <div className="grid">
      <div className="pic" role="img" aria-label="A resident at work in the maker studio" style={{ backgroundImage: `url('${IMAGES.studio}')` }}></div>
      <div className="panel reveal">
        <span className="eyebrow">A Day at Wynridge</span>
        <h2 className="display">The lifestyle you've been <em>working toward</em>.</h2>
        <p>Open the morning with a fitness class. Linger over coffee with a friend. Drop in on a cooking demo, take the long way around the trails, or lose a happy afternoon at the pottery wheel.</p>
        <p>When evening comes, there's a gathering just down the hall — or the quiet of a home that's exactly as you left it.</p>
        <p className="emph">Here, the day isn't scheduled for you. It's designed around you.</p>
      </div>
    </div>
  </section>
);

export const Gallery = ({ onRegister }) => (
  <section className="card gal pad" id="community">
    <div className="inner">
      <div className="top reveal">
        <h2 className="display">Come for the lifestyle. <em>Stay for the people.</em></h2>
        <p className="sub">Most arrive for the freedom and the simplicity. They stay because — somewhere between the shared meals and the easy conversations — it started to feel like home.</p>
      </div>
      <div className="ggrid">
        {GALLERY.map((g, i) => (
          <div key={i} className="gitem reveal">
            <img src={g.img} alt={g.alt} loading="lazy" />
            <div className="lb"><span className="t">{g.t}</span><span className="c">{g.c}</span></div>
          </div>
        ))}
      </div>
      <div className="cta reveal"><a href="#register" className="pill pill-light" onClick={(e) => { e.preventDefault(); onRegister(); }}>Explore the Lifestyle</a></div>
    </div>
  </section>
);

export const Newsletter = ({ onSubmit, submitted, email, setEmail, error }) => (
  <section className="card news pad">
    <img className="mark" src={BRAND.mark} alt="" />
    <div className="inner reveal">
      <div className="lt">
        <span className="eyebrow">Be First</span>
        <h2 className="display" style={{ marginTop: 10 }}>Be first through the <em>door</em>.</h2>
        <p>Join the list for first access — opening dates, community news, and the things worth knowing. No noise.</p>
      </div>
      <div className="rt">
        {!submitted ? (
          <form onSubmit={onSubmit}>
            <input type="email" placeholder="Your email address" required aria-label="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <button type="submit" className="pill pill-dark">Sign Up</button>
          </form>
        ) : (
          <p className="ok">You're on the list — welcome to Wynridge.</p>
        )}
        {error && <p className="rf-error" style={{ marginTop: 10 }}>{error}</p>}
      </div>
    </div>
  </section>
);

export const FinalCTA = ({ onRegister }) => (
  <section className="card final" id="register">
    <div className="grid">
      <div className="panel reveal">
        <span className="eyebrow" style={{ color: "var(--sage)" }}>Get Started</span>
        <h2 className="display" style={{ marginTop: 14 }}>The best years of your life <em>haven't happened yet.</em></h2>
        <p>A community where friendships come easily, the days feel fuller, and life feels lighter. Be among the very first to call Wynridge home.</p>
        <a href="#" className="pill pill-light" onClick={onRegister}>Register Your Interest</a>
        <div className="faq">
          {FAQS.map((f, i) => (
            <details key={i} open={f.open}>
              <summary>{f.q}</summary>
              <p>{f.a}</p>
            </details>
          ))}
        </div>
      </div>
      <div className="pic" role="img" aria-label="Walking the landscaped Wynridge grounds" style={{ backgroundImage: `url('${IMAGES.grounds}')` }}></div>
    </div>
  </section>
);
